import React from 'react';
import '../styles/grid.css';

const Grid = ({ children }) => {
  return <div className="grid-container">{children}</div>;
};

export default Grid;
